import { useEffect, useState } from 'react';

export function useDynamicPageSize(itemHeight = 60, bufferPages = 2, offset = 200) {
    const [pageSize, setPageSize] = useState(0);

    const computePageSize = () => {
        const availableHeight = window.innerHeight - offset;
        const rows = Math.floor(availableHeight / itemHeight);
        return rows * bufferPages; // Fill 2+ pages based on zoom level
    };

    useEffect(() => {
        const handleResize = () => {
            setPageSize(computePageSize());
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return pageSize;
}
